// TODO: Update key value when available - Task 8947815: Update info popup key
export const dateManagementInfoKey = 'pop_BA_CampaignCreate_Budget_BidStrategy';

export const dateSettingsManageAtAdGroupLevelText = _TL_('Start and end dates for this campaign are managed at the ad group level. To edit, go to your ad group settings. ');
